import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import SearchBar from "./common/SearchBar";
import Loader from "./common/Loader";


function Ticket({ticket}){
  console.log(ticket)
  return (
    <>
      <tr className="">
        {ticket.viewed == true ?
          <>
            <td><Link to={`/ticket/` + ticket.id}>Обращение № {ticket.id}</Link></td>
          </>
        :
          <>
            <td><b><Link to={`/ticket/` + ticket.id}>Обращение № {ticket.id}</Link></b></td>
          </>
        }
        <td>{ticket.creator.username}</td>
        <td>{ticket.modified}</td>
        <td>{ticket.created}</td>
        {/*
        {ticket.status === "OPENED" && <td><span className="">{ticket.status}</span></td>}
        {ticket.status === "RESOLVED" && <td><span className="text-success">{ticket.status}</span></td> }
        */}
      </tr>
    </>
  )
}





export default function Tickets ({}){
  const[tickets, setTickets] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  React.useEffect(() => {

    let apiReturnedTickets = axios_api.get(api_url + '/tickets_legal/', {
      headers: {"Authorization": token},
      // params: {"year": selectedYear}
    });

    apiReturnedTickets.then(
      (result) => {
        //console.log(result);
        setTickets(result.data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );

  }, []);

  let rows = [];
  for (let i in tickets) {
    if (tickets[i].creator.username.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
      //pass
    } else {
      rows.push(
        <Ticket 
          key={i} 
          ticket={tickets[i]}
        />
      ); 
    }  
  }


  return ( loading ? 
    (
      <Loader/>
    ) : (
      <>
        <div className="row">
          <h3 className="m-3">Обращения</h3>
        </div>
        <div className="m-3">
          <SearchBar
            key="SearchBar" 
            searchText={searchText} 
            onSearchtextChange={setSearchText} 
          />
        </div>
        <div className="row">
          <div className="col-6 m-3">
            <table className="table">
              <thead>
                <tr>
                  <th>№ обращения</th>   
                  <th>лаборатория</th>
                  <th>последнее изменение</th>     
                  <th>создано</th>       
                </tr>
              </thead>
              <tbody>
                {rows} 
              </tbody>
            </table>
          </div>  
        </div>  
      </>
    )
  )
}

